<template>
    <b-row class="custom-row-table">
        <b-table
            striped
            hover
            :items="items"
            :fields="fields"
            table-variant="light"
            borderless
            :head-variant="headColor"
        ></b-table>
    </b-row>
</template>

<script>
import { API_ROOT } from '../Constants/Api'
import { ApiRequest } from '../helpers/ApiRequest'
import { NumberFormat } from '../helpers/NumberFormat'
export default {
    name: 'TableBase',
    props: ['headColor', 'headText', 'program', 'busy', 'subtype'],
    data: () => ({
        items: [],
        pathName: ''
    }),
    computed: {
        fields() {
            return [
                {
                    key: 'name', //name
                    sortable: true,
                    label: this.translate('Unit'),
                    thStyle: {
                        backgroundColor: this.headColor,
                        color: this.headText
                    }
                },
                {
                    key: 'description',
                    label: this.translate('Description'),
                    thStyle: {
                        backgroundColor: this.headColor,
                        color: this.headText
                    }
                },
                {
                    key: 'amount',
                    label: this.translate('Quantity'),
                    thStyle: {
                        backgroundColor: this.headColor,
                        color: this.headText
                    }
                },
                {
                    key: 'price',
                    label: this.translate('Price'),
                    thStyle: {
                        backgroundColor: this.headColor,
                        color: this.headText
                    }
                },
                {
                    key: 'priceTotal',
                    label: this.translate('PriceTotal'),
                    thStyle: {
                        backgroundColor: this.headColor,
                        color: this.headText
                    }
                }
            ]
        }
    },

    created() {
        this.pathName = this.$route.params.name
    },
    async mounted() {
        const Datos = await ApiRequest.get(`${API_ROOT}preconfiguracion/getAllConjuntoMedicamentos`)
        let ArtSeleccionado = sessionStorage.getItem('Article')?.split(',')[1]
        if (Datos.ok == true && this.pathName === 'sspta') {
            let ConjuntosEncontrados = Datos.data
            for (let n = 0; n < ConjuntosEncontrados.length; n++) {
                if (ConjuntosEncontrados[n].articulo == ArtSeleccionado) {
                    let Sustituto =
                        ConjuntosEncontrados[n].newArticulo +
                        ',' +
                        ConjuntosEncontrados[n].newCodigoAlterno
                    //Variable para el PDF
                    let NewArray = []
                    let ArticulosActuales = JSON.parse(sessionStorage.getItem('arregloArticulos'))
                    let pipelineIdNow = ArticulosActuales[0].data.pipelineId
                    let dealstageNow = ArticulosActuales[0].data.dealstage
                    let UnidadNegocioNow = ArticulosActuales[0].data.UnidadNegocio
                    let PorcentajeMexicoNow = ArticulosActuales[0].data.PorcentajeMexico
                    let PorcentajeUSNow = ArticulosActuales[0].data.PorcentajeUS
                    console.log('pipelineIdNow', pipelineIdNow)
                    console.log('dealstageNow', dealstageNow)
                    console.log('Articulos actuales', ArticulosActuales)
                    for (let i = 0; i < ArticulosActuales.length; i++) {
                        if (ArticulosActuales[i].description == ArtSeleccionado) {
                            console.log('No se cuenta bec')
                        } else if (
                            ArticulosActuales[i].description ==
                            ConjuntosEncontrados[n].articulos[1].description
                        ) {
                            console.log('No se cuenta pgta')
                        } else {
                            NewArray.push(ArticulosActuales[i])
                        }
                    }
                    // Procesar ambos artículos del conjunto de manera más limpia
                    ConjuntosEncontrados[n].articulos.forEach(articulo => {
                        NewArray.push({
                            name: articulo.name,
                            value: articulo.value,
                            amount: articulo.amount,
                            price: articulo.price,
                            description: articulo.description,
                            currencyFormat: articulo.currencyFormat,
                            data: {
                                ...articulo.data,
                                UnidadNegocio: UnidadNegocioNow,
                                PorcentajeMexico: PorcentajeMexicoNow,
                                PorcentajeUS: PorcentajeUSNow,
                                pipelineId: pipelineIdNow,
                                dealstage: dealstageNow
                            }
                        })
                    })

                    sessionStorage.setItem('Article', Sustituto)
                    sessionStorage.setItem('arregloArticulos', JSON.stringify(NewArray))
                }
            }
        }

        let tableTabledata =
            JSON.parse(
                sessionStorage.getItem(
                    this.pathName === 'sspta' ? 'arregloArticulos' : 'arrayMedicine'
                )
            ) || []

        tableTabledata.forEach(el => {
            el.priceTotal =
                (el.currencyFormat === 'Pesos' ? 'MXN ' : 'USD ') +
                NumberFormat(Number(el.price) * Number(el.amount))
            el.price = (el.currencyFormat === 'Pesos' ? 'MXN ' : 'USD ') + NumberFormat(el.price)
        })

        if (this.program) {
            this.items = tableTabledata.filter(el =>
                ['BEC INTERNACIONAL', 'COVERAGE', 'BEC'].includes(el.name)
            )
            if (this.items.some(el => el.description === 'BEC 3 PROT50')) {
                let prot = JSON.parse(sessionStorage.getItem('PROT 50'))
                let addItem = {
                    name: prot.Categoria,
                    value: prot.Articulo,
                    amount: '1',
                    price:
                        (prot.monedaPrecio === 'Pesos' ? 'MXN ' : 'USD ') +
                        NumberFormat(prot.PrecioLista),
                    description: prot.CodigoAlterno,
                    currencyFormat: prot.monedaPrecio,
                    priceTotal: ''
                }
                addItem.priceTotal =
                    (prot.monedaPrecio === 'Pesos' ? 'MXN ' : 'USD ') +
                    NumberFormat(Number(prot.PrecioLista) * Number(addItem.amount))
                this.items.push(addItem)
            }
        }

        if (!this.program && !this.subtype) {
            this.items = tableTabledata.filter(
                el => !['BEC INTERNACIONAL', 'COVERAGE', 'BEC', 'MORE'].includes(el.name)
            )
        }
        if (!this.program && this.subtype) {
            this.items = tableTabledata.filter(el => ['MORE'].includes(el.name))
        }
    },

    methods: {
        translate(name) {
            return this.$i18n.t('recipe.Table.' + name)
        }
    }
}
</script>

<style scoped>
@import '../assets/css/global.css';

.custom-row-table {
    background-color: #fff;
    padding: 0;
    margin: 0;
    /* padding: 12px 0px 2px 0px;
  margin: 40px 0px 20px 0px; */
    /* border-radius: 12px; */
    /* overflow: hidden; */
}

.textDonante {
    text-decoration: line-through;
    color: red;
}
</style>
